import "./App.css";
import Routes from "./Routes/router";
import { BrowserRouter } from "react-router-dom";
import { useEffect, useState } from "react";
import { PUT_AUTHENTICATE } from "./helpers/endpointService";
import { PulseLoader } from "react-spinners";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { fabClasses } from "@mui/material";
import { logoutFunction } from "./components/custom/commonFunction";
import { useCookies, CookiesProvider } from "react-cookie";

function App() {
  const [value, setValue] = useState(false);
  const [decodedData, setDecodedData] = useState({});
  const [dataCode, setDataCode] = useState("");
  const [isAppLoader, setisAppLoader] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies("");

  const handleSignInButtonClick = () => {
    localStorage.setItem("userCheck", "true");
    const redirectUri = process.env.REACT_APP_REDIRECTURI;
    const clientId = process.env.REACT_APP_CLIENTID;
    const scope = process.env.REACT_APP_SCOPE;
    const accesstype = process.env.REACT_APP_ACCESS_TYPE;
    const prompt = process.env.REACT_APP_PROMPT;
    const authUrl =
      process.env.REACT_APP_AUTHURL +
      `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"none"}`;
    window.location.href = authUrl;
  };

  useEffect(() => {
    const token = cookies?.refreshTokenDMS;
    if (token && token !== "undefined" && token !== "null") {
      handleRefreshTokenCookie(cookies?.refreshTokenDMS);
      // setValue(true);
    } else {
      if (
        localStorage.getItem("userClick") == "true" &&
        JSON.parse(localStorage.getItem("userData"))?.id_token == undefined &&
        localStorage.getItem("userCheck") != "true"
      ) {
        localStorage.clear();
      }
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      if (localStorage.getItem("userClick") != "true" && code == null) {
        localStorage.setItem("userClick", "true");
        document.getElementById("container")?.click();
      } else {
        if (
          code == null &&
          JSON.parse(localStorage.getItem("userData"))?.id_token == undefined
        ) {
          const redirectUri = process.env.REACT_APP_REDIRECTURI;
          const clientId = process.env.REACT_APP_CLIENTID;
          const scope = process.env.REACT_APP_SCOPE;
          const accesstype = process.env.REACT_APP_ACCESS_TYPE;
          const prompt = process.env.REACT_APP_PROMPT;
          const authUrl =
            process.env.REACT_APP_AUTHURL +
            `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"consent"}`;
          window.location.href = authUrl;
        } else {
          setisAppLoader(true);
          if (code) {
            setDataCode(code);
            const data = {
              code: code,
              client_id: process.env.REACT_APP_CLIENTID,
              client_secret: process.env.REACT_APP_CLIENTSECRET,
              redirect_uri: process.env.REACT_APP_REDIRECTURI,
              grant_type: process.env.REACT_APP_GRANTTYPE,
            };
            getToken(data);
          }
        }
      }
    }

    setInterval(() => {
      let datetime = Math.round(new Date().getTime() / 1000);
      if (localStorage.getItem("userData") != undefined) {
        if (
          localStorage.getItem("userexpires") == undefined &&
          localStorage.getItem("expiresAtStart") < datetime &&
          localStorage.getItem("expiresAtEnd") > datetime
        ) {
          // console.log("token expiration updated")
          localStorage.setItem("userexpires", "true");
          handleRefreshToken();
        }
      }
    }, 100);

    if (
      JSON.parse(localStorage.getItem("userData"))?.id_token != null &&
      JSON.parse(localStorage.getItem("userData"))?.id_token != undefined
    ) {
      setValue(true);
      setisAppLoader(false);
    }
  }, []);

  const handleRefreshTokenCookie = async (token) => {
    const tokenUrl = process.env.REACT_APP_GOOGLETOKEN;
    const requestBody = {
      refresh_token: token,
      client_id: process.env.REACT_APP_CLIENTID,
      client_secret: process.env.REACT_APP_CLIENTSECRET,
      grant_type: "refresh_token",
    };
    try {
      const response = await fetch(tokenUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(requestBody),
      });
      if (response.ok) {
        const { id_token } = await response.json();
        const accessToken = id_token;
        let obj = {
          refresh_token: token,
          id_token: id_token,
        };
        localStorage.setItem("userData", JSON.stringify(obj));
        const decodedToken = jwtDecode(accessToken);
        setDecodedData(decodedToken);
        localStorage.setItem("userDataDecode", JSON.stringify(decodedToken));
        setTokenDetails();
        let expiresDateStart = Math.round(
          new Date(
            new Date().setMinutes(new Date().getMinutes() + 56)
          ).getTime() / 1000
        );
        let expiresDateEnd = Math.round(
          new Date(
            new Date().setMinutes(new Date().getMinutes() + 57)
          ).getTime() / 1000
        );
        localStorage.setItem("expiresAtStart", expiresDateStart);
        localStorage.setItem("expiresAtEnd", expiresDateEnd);
      } else {
        console.error("Failed to refresh access token:", response.status);
      }
    } catch (error) {
      localStorage.clear();
      const cookieOptions = {
        domain: process.env.REACT_APP_COMMON_DOMAIN,
        path: "/",
      };
      removeCookie("refreshTokenDMS", cookieOptions);
      const redirectUri = process.env.REACT_APP_REDIRECTURI;
      const clientId = process.env.REACT_APP_CLIENTID;
      const scope = process.env.REACT_APP_SCOPE;
      const accesstype = process.env.REACT_APP_ACCESS_TYPE;
      const prompt = process.env.REACT_APP_PROMPT;
      const authUrl =
        process.env.REACT_APP_AUTHURL +
        `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"consent"}`;
      window.location.href = authUrl;
      console.error("Failed to refresh access token:", error);
    }
  };

  const handleRefreshToken = async () => {
    const tokenUrl = process.env.REACT_APP_GOOGLETOKEN;
    const requestBody = {
      refresh_token:
        JSON.parse(localStorage.getItem("userData"))?.refresh_token ??
        cookies?.refreshTokenDMS,
      client_id: process.env.REACT_APP_CLIENTID,
      client_secret: process.env.REACT_APP_CLIENTSECRET,
      grant_type: "refresh_token",
    };
    try {
      const response = await fetch(tokenUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(requestBody),
      });
      if (response.ok) {
        const { id_token } = await response.json();
        const retrievedString = localStorage.getItem("userData");
        const parsedObject = JSON.parse(retrievedString);
        parsedObject.id_token = id_token;
        const updateUser = JSON.stringify(parsedObject);
        localStorage.setItem("userData", updateUser);
        updateTokenDetails(id_token);
        let expiresDateStart = Math.round(
          new Date(
            new Date().setMinutes(new Date().getMinutes() + 56)
          ).getTime() / 1000
        );
        let expiresDateEnd = Math.round(
          new Date(
            new Date().setMinutes(new Date().getMinutes() + 57)
          ).getTime() / 1000
        );
        localStorage.setItem("expiresAtStart", expiresDateStart);
        localStorage.setItem("expiresAtEnd", expiresDateEnd);
        localStorage.removeItem("userexpires");
      } else {
        console.error("Failed to refresh access token:", response.status);
      }
    } catch (error) {
      console.error("Failed to refresh access token:", error);
    }
  };

  const updateTokenDetails = async (token) => {
    const userMail = JSON.parse(localStorage.getItem("userDataDecode"))?.email;
    let apiUrl = `${PUT_AUTHENTICATE}?token=${token}&email=${userMail}&applicationName=DMS`;
    axios({
      method: "PUT",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200 && response.data === true) {
        }
      })
      .catch((err) => {
        //console.log(err)
      });
  };

  const getToken = (data) => {
    let AuthData = localStorage.getItem("userDataDecode");
    fetch(process.env.REACT_APP_GOOGLETOKEN, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.id_token != undefined) {
          const accessToken = data.id_token;
          localStorage.setItem("userData", JSON.stringify(data));
          const cookieOptions = {
            domain: process.env.REACT_APP_COMMON_DOMAIN,
            path: "/",
          };
          setCookie("refreshTokenDMS", data?.refresh_token, cookieOptions);
          const decodedToken = jwtDecode(accessToken);
          setDecodedData(decodedToken);
          localStorage.setItem("userDataDecode", JSON.stringify(decodedToken));
          setTokenDetails();
          let expiresDateStart = Math.round(
            new Date(
              new Date().setMinutes(new Date().getMinutes() + 56)
            ).getTime() / 1000
          );
          let expiresDateEnd = Math.round(
            new Date(
              new Date().setMinutes(new Date().getMinutes() + 57)
            ).getTime() / 1000
          );
          localStorage.setItem("expiresAtStart", expiresDateStart);
          localStorage.setItem("expiresAtEnd", expiresDateEnd);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const setTokenDetails = async () => {
    let AuthData = JSON.parse(localStorage.getItem("userData"));
    const userMail = JSON.parse(localStorage.getItem("userDataDecode"))?.email;
    setisAppLoader(true);
    let apiUrl = `${PUT_AUTHENTICATE}?token=${AuthData?.id_token}&email=${userMail}&applicationName=DMS`;
    setisAppLoader(true);
    axios({
      method: "PUT",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          setisAppLoader(false);
          setValue(true);
        }
      })
      .catch((err) => {
        setValue(true);
        //console.log(err)
        setisAppLoader(false);
        logoutFunction(err?.response?.status);
      });
  };

  return (
    <>
      {value == false && (
        <button
          onClick={handleSignInButtonClick}
          style={{ display: "none" }}
          id="container"
        >
          Sign in with Google
        </button>
      )}
      {isAppLoader && (
        <div className="loader">
          <div className="spinner_overlay">
            <div className="loader">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        </div>
      )}

      {value && (
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
